/**
 * /customers
 *
 * Owner sees money. An agent gets the same list with the contact and the money absent,
 * because the API never sent them. The role check here decides what to render, not what is
 * allowed: the server is the control.
 */
import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { useSession } from '@/app/session';
import { CustomerList } from '@/features/customers/CustomerList';

function CustomersPage() {
  const { role } = useSession();
  return (
    <CustomerList
      onOpen={(customerKey) => {
        window.location.assign(`/customers/${encodeURIComponent(customerKey)}`);
      }}
      role={role ?? 'agent'}
    />
  );
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/customers',
  component: CustomersPage,
});
